import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { axiosGet, axiosPost } from "../../api/Axios";

export const getAllNewsLetterSubscribers = createAsyncThunk(
  "/admin/newsLetter/getAllNewsLetterSubscribers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<INewsLetterSubscriber[]>(
        `/admin/newsLetter/getAllNewsLetterSubscribers`
      );
      return response; // Return the user profile data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);

const initialState: INewsLetterSliceProp = {
  errors: [],
  isError: false,
  isApiLoading: true,
  newsLetters: [],
};

export const newsLetterSlice = createSlice({
  name: "newsLetter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getAllNewsLetterSubscribers.pending, (state) => {
        state.isApiLoading = true;
        state.isError = false;
      })
      .addCase(getAllNewsLetterSubscribers.fulfilled, (state, action) => {
        state.isApiLoading = false;
        state.newsLetters = action.payload;
      })
      .addCase(getAllNewsLetterSubscribers.rejected, (state, action) => {
        state.isApiLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      });
  },
});

export const {} = newsLetterSlice.actions;

export default newsLetterSlice.reducer;
